"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SystemMenu = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const bridge_1 = require("@completeanatomy/bridge");
const bridge_schema_1 = require("@completeanatomy/bridge-schema");
const i18n_1 = require("@completeanatomy/i18n");
const ui_1 = require("@completeanatomy/ui");
const styled_components_1 = __importDefault(require("styled-components"));
const SystemMenuItem_1 = __importDefault(require("../../atoms/SystemMenuItem"));
const SliderInteraction_1 = __importDefault(require("../SliderInteraction"));
// eslint-disable-next-line max-lines-per-function
function SystemMenu({ system, isExpanded, isSelected, isMobile, onClick, resetButtonPressed, setResetButtonPressed, }) {
    const bridge = (0, bridge_1.useBridge)();
    const { t } = (0, i18n_1.useTranslation)();
    const onItemClick = (id) => {
        return () => {
            onClick(id);
        };
    };
    const onSliderClick = (id, mode, value) => {
        bridge === null || bridge === void 0 ? void 0 : bridge.changeSystemState({ identifier: id, mode: mode, value: value });
    };
    const onReset = (id) => {
        return () => {
            if (!isExpanded) {
                return;
            }
            bridge === null || bridge === void 0 ? void 0 : bridge.changeSystemState({
                identifier: id,
                mode: bridge_schema_1.SystemsMenuAction.Reset,
            });
        };
    };
    const desktopDirection = isExpanded ? 'top' : 'right';
    const mobilieDirection = isExpanded ? 'right' : 'bottom';
    const direction = isMobile ? mobilieDirection : desktopDirection;
    const desktopAlign = isExpanded ? 'left' : 'center';
    const mobileAlign = 'center';
    const align = isMobile ? mobileAlign : desktopAlign;
    const iconWidth = isMobile && !isExpanded ? 38 : 31;
    const iconHeight = isMobile && !isExpanded ? 39 : 31;
    let subtitle;
    if (!system.subtitle) {
        subtitle =
            system.activeLayerIndex == -1
                ? t(i18n_1.Strings.systemsMenu.layersOff)
                : t(i18n_1.Strings.systemsMenu.layersOn);
    }
    else {
        subtitle = system.subtitle;
    }
    return ((0, jsx_runtime_1.jsxs)(Container, { onClick: onItemClick(system.identifier), "$isSelected": isSelected, "$isExpanded": isExpanded, "$isDisabled": system.isDisabled, tabIndex: -1, "$isMobile": isMobile, "data-e2e": 'SystemMenu_Container', children: [(0, jsx_runtime_1.jsxs)(SystemMenuContainer, { tabIndex: -1, "data-e2e": 'SystemMenu_SystemMenuContainer', children: [system.isResetButtonActive && ((0, jsx_runtime_1.jsxs)(StyledResetContainer, { "$isActive": isSelected, "$isExpanded": isExpanded, "$isMobile": isMobile, "data-e2e": 'SystemMenu_StyledResetContainer', children: [(0, jsx_runtime_1.jsx)(StyledResetBtnContainer, { "$isExpanded": isExpanded, "$isMobile": isMobile, onClick: onReset(system.identifier), tabIndex: !system.isDisabled && system.isResetButtonActive ? 0 : -1, "data-e2e": 'SystemMenu_StyledResetBtnContainer', children: (0, jsx_runtime_1.jsx)(StyledResetBtn, { width: 10, height: 10, onClick: () => { }, "$isActive": isSelected, "$isExpanded": isExpanded, tabIndex: -1, "data-e2e": 'SystemMenu_StyledResetBtn' }) }), isExpanded && isSelected && ((0, jsx_runtime_1.jsx)(ResetText, { "data-e2e": 'SystemMenu_ResetText', children: (0, i18n_1.Localized)(i18n_1.Strings.common.showHiddenBreak) }))] })), (0, jsx_runtime_1.jsx)(SystemMenuItem_1.default, Object.assign({}, system, { isExpanded: isExpanded, isMobile: isMobile, direction: direction, align: align, title: system.title + (isExpanded ? ': ' + subtitle : ''), isActive: system.isActive || isSelected || false, onClick: () => { }, iconHeight: iconHeight, iconWidth: iconWidth, fontSize: 16, isSelected: isSelected, style: { padding: '0' }, tabIndex: system.isDisabled ? -1 : 0, "data-e2e": 'SystemMenu_SystemMenuItem' }))] }), isExpanded && ((0, jsx_runtime_1.jsx)(SliderContainer, { "$isMobile": isMobile, "$isActive": isSelected && system.isResetButtonActive, "data-e2e": 'SystemMenu_SliderContainer', children: (0, jsx_runtime_1.jsx)(SliderInteraction_1.default, Object.assign({}, system, { sliderWidth: isMobile ? '100%' : undefined, onEvent: onSliderClick, resetButtonPressed: resetButtonPressed, setResetButtonPressed: setResetButtonPressed, "data-e2e": 'SystemMenu_SliderInteraction' })) }))] }));
}
exports.SystemMenu = SystemMenu;
const StyledResetContainer = styled_components_1.default.div `
  position: ${({ $isActive, $isExpanded }) => {
    switch (true) {
        case $isActive && $isExpanded:
            return 'relative';
        default:
            return 'absolute';
    }
}};

  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-content: flex-start;

  & svg {
    color: ${({ theme }) => theme.grasshopper.systemMenus.svgArrow};
  }

  margin-left: ${({ $isActive, $isExpanded, $isMobile }) => {
    switch (true) {
        case $isActive && $isExpanded:
            return '0';
        case !$isActive && $isExpanded:
            return '10px';
        case $isMobile:
            return '30px';
        default:
            return '20px';
    }
}};
  margin-bottom: ${({ $isActive }) => ($isActive ? '8px' : '0')};
  margin-top: ${({ $isExpanded, $isActive }) => {
    switch (true) {
        case $isExpanded && !$isActive:
            return '20px';
        default:
            return '0';
    }
}};

  z-index: 9;
`;
const StyledResetBtnContainer = styled_components_1.default.div `
  margin: ${({ $isExpanded }) => ($isExpanded ? '0px 4px 0px 8px' : '0')};
  margin-bottom: ${({ $isMobile }) => ($isMobile ? '18px' : '0')};

  &:focus-visible {
    outline: none;
    border: 2px solid ${({ theme }) => theme.designSystem.accent};
  }
`;
const StyledResetBtn = (0, styled_components_1.default)(ui_1.ResetButton) `
  width: ${({ $isExpanded, $isActive }) => $isExpanded && $isActive ? '20px' : '14px'};
  height: ${({ $isExpanded, $isActive }) => $isExpanded && $isActive ? '20px' : '14px'};

  padding: 0;

  &:hover {
    opacity: 0.8;
  }
`;
const ResetText = styled_components_1.default.div `
  position: relative;
  font-size: 16px;
  color: ${({ theme }) => theme.grasshopper.systemMenus.text};

  font-weight: 400;
  margin-top: 2px;
  margin-left: 8px;

  & br {
    content: ' '; /* Remove break */
    margin-right: 6px; /* Set space between text blocks */
  }
`;
const SystemMenuContainer = styled_components_1.default.div `
  width: 100%;
  padding: ${({ $isExpanded }) => ($isExpanded ? '0px 4px 0px 4px' : '8px')};
  margin: 0;
  white-space: nowrap;
  box-sizing: border-box;
`;
const SliderContainer = styled_components_1.default.div `
  position: ${({ $isMobile }) => ($isMobile ? 'relative' : 'absolute')};
  margin-left: ${({ $isMobile }) => ($isMobile ? '0' : '24px')};
  margin-top: ${({ $isMobile, $isActive }) => $isMobile ? '0' : $isActive ? '42px' : '16px;'};
`;
const Container = styled_components_1.default.div `
  width: 100%;
  display: ${({ $isMobile }) => ($isMobile ? 'block' : 'flex')};
  justify-content: flex-start;
  align-items: center;

  padding: 4px -8px 4px 4px;

  border-radius: 4px;
  cursor: pointer;

  opacity: ${({ $isDisabled }) => ($isDisabled ? 0.2 : 1)};
  pointer-events: ${({ $isDisabled }) => ($isDisabled ? 'none' : 'auto')};
  user-select: none;

  background-color: ${({ theme, $isSelected, $isMobile }) => $isSelected && !$isMobile
    ? theme.grasshopper.menuButtons.hoverBackground
    : 'transparent'};

  &:hover {
    background-color: ${({ theme, $isMobile, $isExpanded }) => $isMobile && $isExpanded
    ? 'transparent'
    : theme.grasshopper.menuButtons.hoverBackground};
  }
`;
